module.exports = __webpack_public_path__ + "img/focus-time.de48a855.png";